import {useAppNavigation} from "../../../app-layout/AppPages";
import {GoToCategory} from "../GoToItem";
import {RemoteValue} from "../../../util/RemoteValue";
import {useGoToItems} from "./useGoToItems";

export function useSidebarGoToItems(): RemoteValue<GoToCategory> {
    const appNavigation = useAppNavigation();

    return useGoToItems(
        'Navigation',
        [],
        RemoteValue.fromValue(appNavigation),
        appNavigation => appNavigation.sidebar.flatMap(section =>
            section.pages.map(page => ({
                id: `sidebar-${page.path}`,
                label: page.navigation.label,
                icon: () => page.navigation.icon,
                url: pageUrl => pageUrl(page),
            }))
        ),
    );
}
